import customAxios from "./axiosConfig";

const TaxReturnService = {
    list: function (company_id) {
        const api_url = window.Urls['taxreturn_list']() + `?company_id=${company_id}`;
        return customAxios.get(api_url);
    },
    retrieve: function (company_id, year) {
        const api_url = window.Urls['taxreturn_detail'](year) + `?company_id=${company_id}`;
        return customAxios.get(api_url);
    },
    create: function (company_id, year, data) {
        const api_url = window.Urls['taxreturn_list']() + `?company_id=${company_id}&year=${year}`;
        return customAxios.post(api_url, data);
    },
    update: function (id, data) {
        const api_url = window.Urls['taxreturn_detail'](id);
        return customAxios.patch(api_url, data);
    },
    calculate: function (id) {
        const api_url = window.Urls['taxreturn_calculate'](id);
        return customAxios.post(api_url);
    },
    async _blobToBase64(blob) {
        return new Promise((resolve) => {
            const reader = new FileReader()
            reader.readAsDataURL(blob)
            reader.onloadend = () => {
                resolve(reader.result)
            }
        })
    },
    download: function (id) {
        const api_url = window.Urls["taxreturn_download"](id);
        return customAxios.get(api_url, {responseType: "blob"})
            .then((response) => this._blobToBase64(response.data))
    }
};

export default TaxReturnService;
